import { LoadingScreen } from '@/components/LoadingScreen';
import { usePrincipal } from '@/hooks/usePrincipal';
import { PublicLanding } from '@/pages/PublicLanding';
import type * as React from 'react';
import { Navigate } from 'react-router-dom';

/**
 * `/` route element. Branches on principal status:
 *
 *  - `'loading'` → `<LoadingScreen/>` (full-viewport splash; no AppShell
 *    chrome flash before the principal resolves).
 *  - `'authenticated'` → `<Navigate to="/dashboard" replace/>` so authed
 *    visitors land on their workspace, not the public marketing surface.
 *  - `'anonymous'` / `'error'` → `<PublicLanding/>` (anonymous marketing
 *    landing). A principal-level error still leaves the public surface
 *    reachable; failing closed here would lock anon viewers out for a
 *    transient `/api/auth/me` 500.
 *
 * Mounts under `RootGate` so the maintenance gate runs first and the
 * router context is intact for `<Navigate/>`. No permission gate — the
 * route is universally accessible to anon and authed alike.
 */
export function LandingRoute(): React.ReactElement {
  const principal = usePrincipal();
  if (principal.status === 'loading') return <LoadingScreen />;
  if (principal.status === 'authenticated') return <Navigate to="/dashboard" replace />;
  return <PublicLanding />;
}
